
import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export const useProposalDiagnostics = () => {
  // Diagnostic query to track deal status changes
  const { data: diagnosticData } = useQuery({
    queryKey: ['proposal-diagnostics'],
    queryFn: async () => {
      console.log('🔍 [Diagnostics] Running proposal diagnostics...');
      
      // Get recent deals with status 'won'
      const { data: wonDeals, error: wonError } = await supabase
        .from('crm_deals')
        .select('id, title, status, stage_id, created_at, updated_at, value')
        .eq('status', 'won')
        .order('updated_at', { ascending: false })
        .limit(10);

      if (wonError) {
        console.error('❌ [Diagnostics] Error fetching won deals:', wonError);
        return { wonDeals: [], totalWon: 0 };
      }

      console.log('🏆 [Diagnostics] Recent won deals:', wonDeals);
      console.log(`📊 [Diagnostics] Total won deals found: ${wonDeals?.length || 0}`);

      // Get recent proposal notifications with status 'accepted'
      const { data: acceptedNotifications, error: notifError } = await supabase
        .from('proposal_notifications')
        .select('id, deal_id, status, responded_at, created_at')
        .eq('status', 'accepted')
        .order('responded_at', { ascending: false })
        .limit(10);

      if (notifError) {
        console.error('❌ [Diagnostics] Error fetching accepted notifications:', notifError);
      } else {
        console.log('✅ [Diagnostics] Recent accepted notifications:', acceptedNotifications);
      }

      return {
        wonDeals: wonDeals || [],
        totalWon: wonDeals?.length || 0,
        acceptedNotifications: acceptedNotifications || []
      };
    },
    refetchInterval: 30000, // Refetch every 30 seconds for diagnostics
    enabled: true
  });

  useEffect(() => {
    if (diagnosticData) {
      console.log('📊 [Diagnostics] Current diagnostic summary:', {
        wonDealsCount: diagnosticData.totalWon,
        acceptedNotificationsCount: diagnosticData.acceptedNotifications?.length || 0,
        timestamp: new Date().toISOString()
      });
    }
  }, [diagnosticData]);

  return diagnosticData;
};
